module.exports = __webpack_public_path__ + "media/images/background-motorway-3c0cac205183758648896804d06fc307.jpg";